(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-banner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initBlogBannerNewsletterForms = (scope = document) => {
      scope.querySelectorAll('form[id^="blog-banner-newsletter-"]').forEach((form) => {
        if (form.dataset.loadingInitialized === 'true') return;

        form.dataset.loadingInitialized = 'true';
        form.addEventListener('submit', () => {
          const button = form.querySelector('[data-blog-banner-submit]');

          if (!button || button.disabled) return;

          button.classList.add('is-loading');
          button.disabled = true;
          button.setAttribute('aria-busy', 'true');
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initBlogBannerNewsletterForms());
    } else {
      initBlogBannerNewsletterForms();
    }

    document.addEventListener('shopify:section:load', (event) => initBlogBannerNewsletterForms(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["esport-zone-banner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const GLOBAL_KEY = '__esportZoneBannerMotionBooted';
    const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
    const getSectionProgress = (section) => clamp(-section.getBoundingClientRect().top / (window.innerHeight * 2), 0, 1);
    const TRIGGER_SHOW_THRESHOLD = 0.12;
    const TRIGGER_RESET_THRESHOLD = 0.04;

    const createTriggeredMaskController = (section, maskTarget, motion) => {
      if (!maskTarget) {
        return null;
      }

      const SCALE_FROM = 6;
      const SCALE_TO = 1.01;
      const EASING = [0.22, 1, 0.36, 1];
      let animation = null;
      let ticking = false;
      let lastProgress = getSectionProgress(section);
      let state = lastProgress >= TRIGGER_SHOW_THRESHOLD ? 'shown' : 'hidden';

      const stopAnimation = () => {
        if (!animation) {
          return;
        }

        if (typeof animation.stop === 'function') {
          animation.stop();
        } else if (typeof animation.cancel === 'function') {
          animation.cancel();
        }

        animation = null;
      };

      const setMaskState = (isShown) => {
        maskTarget.style.opacity = isShown ? '1' : '0';
        maskTarget.style.transform = 'translateZ(0) scale(' + (isShown ? SCALE_TO : SCALE_FROM) + ')';
      };

      setMaskState(state === 'shown');

      const animateMask = (isShowing) => {
        stopAnimation();

        const keyframes = {
          transform: [
            'translateZ(0) scale(' + (isShowing ? SCALE_FROM : SCALE_TO) + ')',
            'translateZ(0) scale(' + (isShowing ? SCALE_TO : SCALE_FROM) + ')',
          ],
          opacity: isShowing ? [0, 1] : [1, 0],
        };

        if (motion && motion.animate) {
          animation = motion.animate(maskTarget, keyframes, {
            duration: isShowing ? 0.72 : 0.42,
            easing: EASING,
            fill: 'forwards',
          });
          return;
        }

        if (maskTarget.animate) {
          animation = maskTarget.animate(keyframes, {
            duration: isShowing ? 720 : 420,
            easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
            fill: 'forwards',
          });
          return;
        }

        setMaskState(isShowing);
      };

      const triggerShow = () => {
        if (state === 'shown') return;
        state = 'shown';
        animateMask(true);
      };

      const triggerHide = () => {
        if (state === 'hidden') return;
        state = 'hidden';
        animateMask(false);
      };

      const update = () => {
        const progress = getSectionProgress(section);
        const direction = progress - lastProgress;

        if (direction > 0 && progress >= TRIGGER_SHOW_THRESHOLD) {
          triggerShow();
        } else if (direction < 0 && progress <= TRIGGER_RESET_THRESHOLD) {
          triggerHide();
        }

        lastProgress = progress;
      };

      const onScroll = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          update();
          ticking = false;
        });
      };

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);

      return {
        stop: () => {
          window.removeEventListener('scroll', onScroll);
          window.removeEventListener('resize', onScroll);
          stopAnimation();
        },
      };
    };

    const createTriggeredContentController = (section, contentElements, motion) => {
      const animationTargets = [
        {
          element: contentElements.logo,
          distance: 0,
          delay: 0,
        },
        {
          element: contentElements.title,
          distance: -110,
          delay: 0.04,
        },
        {
          element: contentElements.button,
          distance: -72,
          delay: 0.08,
        },
      ].filter((target) => target.element);

      if (!animationTargets.length) {
        return null;
      }

      const EASING = [0.22, 1, 0.36, 1];
      const animations = [];
      let state = 'shown';
      let lastProgress = getSectionProgress(section);
      let ticking = false;

      const stopAnimations = () => {
        animations.forEach((animation) => {
          if (animation && typeof animation.stop === 'function') {
            animation.stop();
          } else if (animation && typeof animation.cancel === 'function') {
            animation.cancel();
          }
        });
        animations.length = 0;
      };

      const setContentState = (isShown) => {
        animationTargets.forEach(({ element, distance }) => {
          element.style.opacity = isShown ? '1' : '0';
          element.style.transform = distance ? `translate3d(0, ${isShown ? 0 : distance}px, 0)` : 'none';
          element.style.willChange = distance ? 'transform, opacity' : 'opacity';
        });
      };

      const runContentAnimation = (isShowing) => {
        stopAnimations();

        animationTargets.forEach(({ element, distance, delay }) => {
          const keyframes = {
            opacity: isShowing ? [0, 1] : [1, 0],
          };

          if (distance) {
            keyframes.transform = isShowing
              ? [`translate3d(0, ${distance}px, 0)`, 'translate3d(0, 0, 0)']
              : ['translate3d(0, 0, 0)', `translate3d(0, ${distance}px, 0)`];
          }

          if (motion && motion.animate) {
            const control = motion.animate(element, keyframes, {
              duration: 0.58,
              easing: EASING,
              fill: 'forwards',
              delay,
            });
            animations.push(control);
          } else if (element.animate) {
            const control = element.animate(keyframes, {
              duration: 580,
              easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
              fill: 'forwards',
              delay: delay * 1000,
            });
            animations.push(control);
          } else {
            element.style.opacity = isShowing ? '1' : '0';
            if (distance) {
              element.style.transform = isShowing ? 'translate3d(0, 0, 0)' : `translate3d(0, ${distance}px, 0)`;
            }
          }
        });
      };

      if (lastProgress >= TRIGGER_SHOW_THRESHOLD) {
        state = 'hidden';
        setContentState(false);
      } else {
        setContentState(true);
      }

      const triggerHide = () => {
        if (state === 'hidden') return;
        state = 'hidden';
        runContentAnimation(false);
      };

      const triggerShow = () => {
        if (state === 'shown') return;
        state = 'shown';
        runContentAnimation(true);
      };

      const update = () => {
        const progress = getSectionProgress(section);
        const direction = progress - lastProgress;

        if (direction > 0 && progress >= TRIGGER_SHOW_THRESHOLD) {
          triggerHide();
        } else if (direction < 0 && progress <= TRIGGER_RESET_THRESHOLD) {
          triggerShow();
        }

        lastProgress = progress;
      };

      const onScroll = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          update();
          ticking = false;
        });
      };

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);

      return {
        stop: () => {
          window.removeEventListener('scroll', onScroll);
          window.removeEventListener('resize', onScroll);
          stopAnimations();
        },
      };
    };

    const setupSection = (section) => {
      if (!section) return;

      if (section.__esportZoneCleanup) {
        section.__esportZoneCleanup();
      }

      const content = section.querySelector('.esport-zone-banner__content');
      const maskLayer = section.querySelector('[data-esport-zone-mask-layer]');
      const maskFallback = section.querySelector('.esport-zone-banner__mask-fallback');
      const contentElements = {
        logo: content ? content.querySelector('[data-esport-zone-content-logo]') : null,
        title: content ? content.querySelector('[data-esport-zone-content-title]') : null,
        button: content ? content.querySelector('[data-esport-zone-content-button]') : null,
      };
      const hasMaskLayer = maskLayer && getComputedStyle(maskLayer).display !== 'none';
      const maskTarget = hasMaskLayer ? maskLayer : maskFallback;
      const modal = section.querySelector('[data-esport-zone-modal]');
      const openButton = section.querySelector('[data-esport-zone-modal-open]');
      const closeButtons = modal ? Array.from(modal.querySelectorAll('[data-esport-zone-modal-close]')) : [];
      const modalVideo = modal ? modal.querySelector('video') : null;

      const motion = window.Motion || {};
      const controls = [];

      const maskTriggerControl = createTriggeredMaskController(section, maskTarget, motion);
      if (maskTriggerControl) {
        controls.push(maskTriggerControl);
      }

      const contentTriggerControl = createTriggeredContentController(section, contentElements, motion);
      if (contentTriggerControl) {
        controls.push(contentTriggerControl);
      }

      if (modal && openButton) {
        let closeTimer = null;
        const rootElement = document.documentElement;

        const openModal = () => {
          if (openButton.hasAttribute('disabled')) return;

          if (closeTimer) {
            window.clearTimeout(closeTimer);
            closeTimer = null;
          }

          modal.hidden = false;
          requestAnimationFrame(() => {
            modal.classList.add('is-open');
          });

          rootElement.classList.add('esport-zone-banner-modal-open');

          if (modalVideo) {
            modalVideo.muted = false;
            modalVideo.controls = true;
            modalVideo.currentTime = 0;
            const playPromise = modalVideo.play();
            if (playPromise && typeof playPromise.catch === 'function') {
              playPromise.catch(() => {});
            }
          }
        };

        const closeModal = () => {
          modal.classList.remove('is-open');
          rootElement.classList.remove('esport-zone-banner-modal-open');

          if (modalVideo) {
            modalVideo.pause();
          }

          if (closeTimer) {
            window.clearTimeout(closeTimer);
          }

          closeTimer = window.setTimeout(() => {
            modal.hidden = true;
          }, 340);
        };

        const onKeydown = (event) => {
          if (event.key === 'Escape' && !modal.hidden) {
            closeModal();
          }
        };

        openButton.addEventListener('click', openModal);
        closeButtons.forEach((button) => button.addEventListener('click', closeModal));
        document.addEventListener('keydown', onKeydown);

        controls.push(() => {
          openButton.removeEventListener('click', openModal);
          closeButtons.forEach((button) => button.removeEventListener('click', closeModal));
          document.removeEventListener('keydown', onKeydown);
          if (closeTimer) {
            window.clearTimeout(closeTimer);
          }
          rootElement.classList.remove('esport-zone-banner-modal-open');
          modal.classList.remove('is-open');
          modal.hidden = true;
          if (modalVideo) {
            modalVideo.pause();
          }
        });
      }

      section.__esportZoneCleanup = () => {
        controls.forEach((control) => {
          if (typeof control === 'function') {
            control();
          } else if (control && typeof control.stop === 'function') {
            control.stop();
          }
        });
      };
    };

    const initAll = () => {
      const sections = document.querySelectorAll('[data-esport-zone-banner]');
      sections.forEach((section) => setupSection(section));
    };

    const boot = () => {
      initAll();

      if (!window.Motion || !window.Motion.animate) {
        let retries = 0;
        const timer = window.setInterval(() => {
          retries += 1;

          if (window.Motion && window.Motion.animate) {
            window.clearInterval(timer);
            initAll();
            return;
          }

          if (retries >= 60) {
            window.clearInterval(timer);
          }
        }, 100);
      }

      if (!window[GLOBAL_KEY]) {
        window[GLOBAL_KEY] = true;

        document.addEventListener('shopify:section:load', (event) => {
          const target =
            event.target && event.target.matches('[data-esport-zone-banner]')
              ? event.target
              : event.target
              ? event.target.querySelector('[data-esport-zone-banner]')
              : null;

          if (target) {
            setupSection(target);
          }
        });
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["event-countdown"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const pad = (value) => String(Math.max(0, value)).padStart(2, '0');

    const parseBeijingDate = (input) => {
      const raw = String(input || '').trim();

      if (!raw) {
        return null;
      }

      if (/[zZ]|[+-]\d{2}:?\d{2}$/.test(raw)) {
        const withZone = new Date(raw);
        return Number.isNaN(withZone.getTime()) ? null : withZone;
      }

      const normalized = raw.replace('T', ' ').replace(/\./g, '-').replace(/\//g, '-');
      const match = normalized.match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:\s+(\d{1,2})(?::(\d{1,2})(?::(\d{1,2}))?)?)?$/);

      if (!match) {
        const fallback = new Date(raw);
        return Number.isNaN(fallback.getTime()) ? null : fallback;
      }

      const year = Number(match[1]);
      const month = Number(match[2]) - 1;
      const day = Number(match[3]);
      const hour = Number(match[4] || 0);
      const minute = Number(match[5] || 0);
      const second = Number(match[6] || 0);

      return new Date(Date.UTC(year, month, day, hour - 8, minute, second));
    };

    document.querySelectorAll('[data-event-countdown]').forEach((root) => {
      const expiration = parseBeijingDate(root.dataset.expirationDate);

      if (!expiration) {
        return;
      }

      const daysEl = root.querySelector('[data-countdown-days]');
      const hoursEl = root.querySelector('[data-countdown-hours]');
      const minutesEl = root.querySelector('[data-countdown-minutes]');
      const secondsEl = root.querySelector('[data-countdown-seconds]');

      const render = () => {
        const remaining = Math.max(0, expiration.getTime() - Date.now());
        const totalSeconds = Math.floor(remaining / 1000);
        const days = Math.floor(totalSeconds / 86400);
        const hours = Math.floor((totalSeconds % 86400) / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        daysEl.textContent = pad(days);
        hoursEl.textContent = pad(hours);
        minutesEl.textContent = pad(minutes);
        secondsEl.textContent = pad(seconds);

        if (remaining > 0) {
          window.setTimeout(render, 1000 - (Date.now() % 1000));
        }
      };

      render();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["event-kol"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-event-kol]').forEach((sectionEl) => {
      const swiperEl = sectionEl.querySelector('.swiper');

      if (!swiperEl) {
        return;
      }

      new Swiper(swiperEl, {
        slidesPerView: 'auto',
        navigation: {
          nextEl: sectionEl.querySelector('[data-next]'),
          prevEl: sectionEl.querySelector('[data-prev]'),
        },
      });

      sectionEl.querySelectorAll('[data-video-media]').forEach((mediaEl) => {
        const videoEl = mediaEl.querySelector('video');
        const toggleEl = mediaEl.querySelector('[data-video-toggle]');

        if (!videoEl || !toggleEl) {
          return;
        }

        const syncState = () => {
          const isPlaying = !videoEl.paused && !videoEl.ended;

          mediaEl.classList.toggle('is-playing', isPlaying);
          toggleEl.setAttribute('aria-hidden', isPlaying ? 'true' : 'false');
        };

        const playVideo = () => {
          document.querySelectorAll('[data-event-kol] video').forEach((otherVideoEl) => {
            if (otherVideoEl !== videoEl && !otherVideoEl.paused && !otherVideoEl.ended) {
              otherVideoEl.pause();
            }
          });

          const playPromise = videoEl.play();

          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(syncState);
          }
        };

        const pauseVideo = () => {
          if (!videoEl.paused && !videoEl.ended) {
            videoEl.pause();
          }
        };

        mediaEl.addEventListener('click', pauseVideo);
        toggleEl.addEventListener('click', (event) => {
          event.stopPropagation();
          playVideo();
        });
        videoEl.addEventListener('play', syncState);
        videoEl.addEventListener('pause', syncState);
        videoEl.addEventListener('ended', syncState);

        syncState();
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iem-esport"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-iem-esport]').forEach((sectionEl) => {
      const swiperEl = sectionEl.querySelector('.swiper');

      if (!swiperEl) {
        return;
      }

      const slideCount = swiperEl.querySelectorAll('.swiper-slide').length;

      new Swiper(swiperEl, {
        slidesPerView: 'auto',
        centeredSlides: true,
        loop: slideCount > 1,
        spaceBetween: 8,
        navigation: {
          nextEl: sectionEl.querySelector('[data-next]'),
          prevEl: sectionEl.querySelector('[data-prev]'),
        },
        breakpoints: {
          768: {
            spaceBetween: 16,
          },
        },
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iem-feature-slide"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-iem-feature-slide]').forEach((sectionEl) => {
      const mediaItems = Array.from(sectionEl.querySelectorAll('[data-iem-feature-media]'));
      const contentItems = Array.from(sectionEl.querySelectorAll('[data-iem-feature-content]'));
      const prevButton = sectionEl.querySelector('[data-iem-feature-prev]');
      const nextButton = sectionEl.querySelector('[data-iem-feature-next]');
      let activeIndex = 0;
      if (!mediaItems.length || !contentItems.length) {
        return;
      }

      const syncVideos = () => {
        mediaItems.forEach((item, index) => {
          item.querySelectorAll('video').forEach((video) => {
            if (index === activeIndex) {
              video.currentTime = video.currentTime || 0;
              video.play().catch(() => {});
            } else {
              video.pause();
            }
          });
        });
      };

      const showSlide = (nextIndex) => {
        const normalizedIndex = (nextIndex + mediaItems.length) % mediaItems.length;

        if (normalizedIndex === activeIndex) {
          return;
        }

        activeIndex = normalizedIndex;

        mediaItems.forEach((item, index) => {
          item.classList.toggle('is-active', index === activeIndex);
        });

        contentItems.forEach((item, index) => {
          item.classList.toggle('is-active', index === activeIndex);
        });

        syncVideos();
      };

      if (prevButton) {
        prevButton.addEventListener('click', () => showSlide(activeIndex - 1));
      }

      if (nextButton) {
        nextButton.addEventListener('click', () => showSlide(activeIndex + 1));
      }

      mediaItems.forEach((item, index) => {
        item.classList.toggle('is-active', index === activeIndex);
      });

      contentItems.forEach((item, index) => {
        item.classList.toggle('is-active', index === activeIndex);
      });

      syncVideos();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iem-nav"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const cssEscape = window.CSS && CSS.escape ? CSS.escape : (value) => value.replace(/[^a-zA-Z0-9_-]/g, '\\$&');

    const getTarget = (targetId) => {
      const cleanId = (targetId || '').trim().replace(/^#/, '');

      if (!cleanId) {
        return null;
      }

      return (
        document.getElementById(cleanId) ||
        document.getElementById(`shopify-section-${cleanId}`) ||
        document.querySelector(`[data-anchor-id="${cssEscape(cleanId)}"]`) ||
        document.querySelector(`[data-section-id="${cssEscape(cleanId)}"]`)
      );
    };

    document.querySelectorAll('[data-iem-nav]').forEach((sectionEl) => {
      const scrollerEl = sectionEl.querySelector('[data-iem-nav-scroller]');
      const navItems = Array.from(sectionEl.querySelectorAll('[data-iem-nav-link]')).map((linkEl) => ({
        linkEl,
        targetId: linkEl.getAttribute('data-target-id') || '',
        targetEl: null,
      }));
      let lockedItem = null;

      const refreshTargets = () => {
        navItems.forEach((item) => {
          item.targetEl = getTarget(item.targetId);
        });
      };

      const getOffset = () => {
        const sectionWrapper = sectionEl.closest('.shopify-section') || sectionEl.parentElement || sectionEl;
        const stickyTop = Number.parseFloat(window.getComputedStyle(sectionWrapper).top) || 0;

        return sectionEl.getBoundingClientRect().height + stickyTop;
      };

      const scrollActiveIntoView = (activeLink, behavior = 'smooth') => {
        if (!scrollerEl || !activeLink || scrollerEl.scrollWidth <= scrollerEl.clientWidth) {
          return;
        }

        const scrollerRect = scrollerEl.getBoundingClientRect();
        const activeRect = activeLink.getBoundingClientRect();
        const activeCenter = activeRect.left - scrollerRect.left + activeRect.width / 2;
        const scrollerCenter = scrollerEl.clientWidth / 2;
        const maxScrollLeft = scrollerEl.scrollWidth - scrollerEl.clientWidth;
        const nextScrollLeft = Math.max(
          0,
          Math.min(scrollerEl.scrollLeft + activeCenter - scrollerCenter, maxScrollLeft)
        );

        if (Math.abs(nextScrollLeft - scrollerEl.scrollLeft) < 1) {
          return;
        }

        scrollerEl.scrollTo({
          left: nextScrollLeft,
          behavior,
        });
      };

      const setActive = (activeLink, behavior = 'smooth') => {
        if (!activeLink) {
          return;
        }

        if (activeLink.classList.contains('is-active')) {
          scrollActiveIntoView(activeLink, behavior);
          return;
        }

        navItems.forEach((item) => {
          item.linkEl.classList.remove('is-active');
          item.linkEl.removeAttribute('aria-current');
        });

        activeLink.classList.add('is-active');
        activeLink.setAttribute('aria-current', 'true');
        scrollActiveIntoView(activeLink, behavior);
      };

      const clearLock = () => {
        lockedItem = null;
      };

      const updateActive = () => {
        if (lockedItem) {
          setActive(lockedItem.linkEl);
          return;
        }

        const offset = getOffset() + 1;
        let activeItem = null;
        let closestPastItem = null;
        let closestPastDistance = Infinity;
        let closestFutureItem = null;
        let closestFutureDistance = Infinity;

        navItems.forEach((item) => {
          if (!item.targetEl) {
            item.targetEl = getTarget(item.targetId);
          }

          if (!item.targetEl) {
            return;
          }

          const rect = item.targetEl.getBoundingClientRect();

          if (rect.top <= offset && rect.bottom > offset) {
            activeItem = item;
            return;
          }

          const distance = rect.top - offset;

          if (distance <= 0 && Math.abs(distance) < closestPastDistance) {
            closestPastDistance = Math.abs(distance);
            closestPastItem = item;
          }

          if (distance > 0 && distance < closestFutureDistance) {
            closestFutureDistance = distance;
            closestFutureItem = item;
          }
        });

        const nextActiveItem = activeItem || closestPastItem || closestFutureItem;

        if (nextActiveItem) {
          setActive(nextActiveItem.linkEl);
        }
      };

      let ticking = false;
      const requestUpdate = () => {
        if (ticking) {
          return;
        }

        ticking = true;
        window.requestAnimationFrame(() => {
          ticking = false;
          updateActive();
        });
      };

      navItems.forEach((item) => {
        item.linkEl.addEventListener('click', (event) => {
          refreshTargets();

          if (!item.targetEl) {
            event.preventDefault();
            return;
          }

          event.preventDefault();
          const top = Math.max(0, item.targetEl.getBoundingClientRect().top + window.scrollY - getOffset());

          setActive(item.linkEl);
          lockedItem = item;
          item.linkEl.blur();

          window.scrollTo({
            top,
            behavior: 'smooth',
          });
        });
      });

      window.addEventListener('wheel', clearLock, { passive: true });
      window.addEventListener(
        'touchstart',
        (event) => {
          if (!sectionEl.contains(event.target)) {
            clearLock();
          }
        },
        { passive: true }
      );
      window.addEventListener('keydown', (event) => {
        if (['ArrowDown', 'ArrowUp', 'PageDown', 'PageUp', 'Home', 'End', ' '].includes(event.key)) {
          clearLock();
        }
      });

      refreshTargets();
      updateActive();
      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iem-top-rated"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-iem-top-rated]').forEach((sectionEl) => {
      const items = Array.from(sectionEl.querySelectorAll('[data-iem-top-rated-item]'));
      const mediaPanels = Array.from(sectionEl.querySelectorAll('[data-iem-top-rated-media]'));

      if (!items.length) {
        return;
      }

      const updatePanelHeights = () => {
        items.forEach((item) => {
          const panel = item.querySelector('[data-iem-top-rated-panel]');
          if (!panel) {
            return;
          }

          panel.style.maxHeight = item.classList.contains('is-active') ? `${panel.scrollHeight}px` : '0px';
        });
      };

      const setActive = (index) => {
        items.forEach((item, itemIndex) => {
          const isActive = itemIndex === index;
          const toggle = item.querySelector('[data-iem-top-rated-toggle]');

          item.classList.toggle('is-active', isActive);
          if (toggle) {
            toggle.setAttribute('aria-expanded', isActive ? 'true' : 'false');
          }
        });

        mediaPanels.forEach((panel, panelIndex) => {
          panel.classList.toggle('is-active', panelIndex === index);
        });

        requestAnimationFrame(updatePanelHeights);
      };

      items.forEach((item, index) => {
        const toggle = item.querySelector('[data-iem-top-rated-toggle]');
        if (!toggle) {
          return;
        }

        toggle.addEventListener('click', () => setActive(index));
      });

      setActive(0);
      window.addEventListener('resize', updatePanelHeights);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iem-user-say"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-iem-user-say]').forEach((sectionEl) => {
      const swiperEl = sectionEl.querySelector('.swiper');

      if (!swiperEl) {
        return;
      }

      new Swiper(swiperEl, {
        slidesPerView: 'auto',
        spaceBetween: 12,
        navigation: {
          nextEl: sectionEl.querySelector('[data-next]'),
          prevEl: sectionEl.querySelector('[data-prev]'),
        },
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
